import { render } from "./TabBar.vue?vue&type=template&id=7d44e3c9&scoped=true&ts=true"
import script from "./TabBar.vue?vue&type=script&lang=ts"
export * from "./TabBar.vue?vue&type=script&lang=ts"

import "./TabBar.vue?vue&type=style&index=0&id=7d44e3c9&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d44e3c9"]])

export default __exports__